'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'circle-7';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e0f4';
var svgPathData = 'M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM200 144l112 0c8.3 0 16 4.3 20.4 11.4s4.8 15.9 1 23.4l-88 176c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2L273.2 192 200 192c-13.3 0-24-10.7-24-24s10.7-24 24-24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircle7 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;